import { isMobileApp } from '@shared/utils/descopeQueryParams';

const QA_DESCOPE_PROJECT_ID = 'P32AChDvEswJtnBOsX26vHeCXTws';

const hasPasskeysQueryParam = (location: Location): boolean => {
  const searchParams = new URLSearchParams(location.search);
  const hashQuery = location.hash.split('?')[1];
  const hashParams = hashQuery ? new URLSearchParams(hashQuery) : undefined;

  return (
    (searchParams.get('passkeys') ?? hashParams?.get('passkeys')) === 'true'
  );
};

const browserSupportsWebAuthn = (): boolean =>
  typeof window.PublicKeyCredential !== 'undefined' &&
  typeof navigator.credentials?.get === 'function' &&
  typeof navigator.credentials?.create === 'function';

export const isQaPasskeysEnabled = (): boolean =>
  import.meta.env.VITE_DESCOPE_PROJECT_ID === QA_DESCOPE_PROJECT_ID &&
  !isMobileApp() &&
  hasPasskeysQueryParam(window.location) &&
  browserSupportsWebAuthn();
